<!--New design

Create reminder messages for permits about to expire

-->
<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="blue_header">
		<h1 class="heading">Manage {{this.lblHeading}}</h1>
	</div>
  <label class="sb-txt">From here you can run the processes that create notifications and reminders based on numerous
    dates and statuses. In the processes, the status of permits may also be altered. The correspondence items are
    inserted into the correspondence subsystem from where the emails and SMSes are sent.<br>Click on the run icon to run
    a process. The process will display a summary when it is complete.</label>

  <!--

    Create reminder messages for permits about to expire

  -->
  <div class="row justify-content-center">
    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox"
              title="This task will find the permits that have an expiry date in range and have not been sent a reminder in last x days and create reminder messages using the templates and controls from configuration entries.">
              1. Permit expiry reminders</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Create reminder messages for permits about to expire</td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.." rel="tooltip"
              data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runExiryCheckTask()"><img src="assets/blue_play.png" alt="" /></button>
                
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isReportVisible"># reminders
                sent for LT permits:
                {{ExpiringReport["tlCount"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isReportVisible"># reminders
                sent for Temp permits:
                {{ExpiringReport["tempCount"]}}</label>
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>

    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="Will also mark permits as not valid if system date is past permit expiry date.">
              2. Permit expired reminders</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Send permit expiry notifications.</td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.."
              rel="tooltip" data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runExpiredCheckTask()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isExpiredReportVisible">#
                reminders sent for LT permits:
                {{ExpiredgReport["tlCount"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isExpiredReportVisible">#
                reminders sent for Temp permits:
                {{ExpiredgReport["tempCount"]}}</label>
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>
  </div>


  <!-- <fieldset class="scheduler-border" style="margin-bottom: 8px !important; padding:0px;">
    <legend class="scheduler-border tsk-display">Create reminder messages for permits about to expire</legend>
    <table class="" style="width:100%!important; padding:0px;" border="0">
      <tr>
        <td>
          <b>Run the process described above</b>
        </td>
        <td align="right">
          <div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runExiryCheckTask()"
            style="margin: 0px auto!important; float: right;" rel="tooltip" data-placement="top">
            <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
              aria-hidden="true"></span>
          </div>
        </td>
      </tr>
    </table>
    <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;" *ngIf="isReportVisible">
      <legend class="scheduler-border tsk-display">Process Report</legend>
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># reminders sent for LT permits:
        {{ExpiringReport["tlCount"]}}</label> <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># reminders sent for Temp permits:
        {{ExpiringReport["tempCount"]}}</label>
    </fieldset>
  </fieldset> -->



  <!--

    Permit has expired notification 

  -->
  <!-- 
  <div class="row justify-content-center">
    <div class="col-md-8" class="card" style="width: 100%;">
       <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="Will also mark permits as not valid if system date is past permit expiry date.">Permit expired reminders</th>
            <th></th>
            <th></th>
            
            </tr>
            </thead>
            <tbody>
              <td class="smallbox">Send permit expiry notifications.</td>
              <td class="smallbox"><div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runExpiredCheckTask()"
                 rel="tooltip" data-placement="top">
                <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                  aria-hidden="true"></span>
              </div></td>
              <td class="smallbox">
                <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;" >
                  <legend class="scheduler-border tsk-display">Process Report</legend>
                  <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isExpiredReportVisible"># reminders sent for LT permits:
                    {{ExpiredgReport["tlCount"]}}</label> <br />
                  <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isExpiredReportVisible"># reminders sent for Temp permits:
                    {{ExpiredgReport["tempCount"]}}</label>
                </fieldset>
              </td>
              
            </tbody>

     </table>
    </div>          
  </div> -->



  <!-- <fieldset class="scheduler-border" style="margin-bottom: 8px !important; padding:0px;">
    <legend class="scheduler-border tsk-display">Permit has expired notification</legend>
    <table class="" style="width:100%!important; padding:0px;" border="0">
      <tr>
        <td>
          <b>Run the process described above</b>
        </td>
        <td align="right">
          <div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runExpiredCheckTask()"
            style="margin: 0px auto!important; float: right;" rel="tooltip" data-placement="top">
            <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
              aria-hidden="true"></span>
          </div>
        </td>
      </tr>
    </table>
    <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;" *ngIf="isExpiredReportVisible">
      <legend class="scheduler-border tsk-display">Process Report</legend>
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># reminders sent for LT permits:
        {{ExpiredgReport["tlCount"]}}</label> <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># reminders sent for Temp permits:
        {{ExpiredgReport["tempCount"]}}</label>
    </fieldset>
  </fieldset> -->


  <!--

    Permits not returned notification

  -->

  <div class="row justify-content-center">
    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox"
              title="This task will select expired and unreturned permits that have not been sent a reminder in last x days. It will create reminder messages for these permits using the templates and controls from configuration entries.">
              3. Permit return reminders</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Send permit not returned notifications.</td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.."
              rel="tooltip" data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runNotReturnedCheckTask()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isNotreturnedReportVisible">#
                reminders sent for LT permits:
                {{NotReturnedReport["tlCount"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isNotreturnedReportVisible">#
                reminders sent for Temp permits:
                {{NotReturnedReport["tempCount"]}}</label>
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>

    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox"
              title="Will also unsubmit applications where payments are overdue.This task will select applications that are submitted, fees accepted and where the fees due have not been paid.">
              4. Fees due reminders</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Create reminder messages for permit fees due. Will also unsubmit applications where
            payments are overdue.</td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.." rel="tooltip"
              data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runFeesDueTask()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFeesDueVisible"># accounts
                where balance changed and thus no
                reminder sent:
                {{FeesDueTReport["balance_changed_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFeesDueVisible"># applications
                unsubmitted:
                {{FeesDueTReport["unsubmit_count"]}}</label>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFeesDueVisible"># reminders
                sent for application fees due:
                {{FeesDueTReport["app_fee_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFeesDueVisible"># reminders
                sent for permit fees due:
                {{FeesDueTReport["permit_fee_count"]}}</label>
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>
  </div>




  <!-- <fieldset class="scheduler-border" style="margin-bottom: 8px !important; padding:0px;">
    <legend class="scheduler-border tsk-display">Permits not returned notification</legend>
    <table class="" style="width:100%!important; padding:0px;" border="0">
      <tr>
        <td>
          <b>Run the process described above</b>
        </td>
        <td align="right">
          <div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runNotReturnedCheckTask()"
            style="margin: 0px auto!important; float: right;" rel="tooltip" data-placement="top">
            <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
              aria-hidden="true"></span>
          </div>
        </td>
      </tr>
    </table>
    <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;" *ngIf="isNotreturnedReportVisible">
      <legend class="scheduler-border tsk-display">Process Report</legend>
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># reminders sent for LT permits:
        {{NotReturnedReport["tlCount"]}}</label> <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># reminders sent for Temp permits:
        {{NotReturnedReport["tempCount"]}}</label>
    </fieldset>
  </fieldset> -->



  <!--

    Create messages for fees due

  -->

  <div class="row justify-content-center">
    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox"
              title="Will also unsubmit applications where payments are overdue.This task will select applications that are submitted, fees accepted and where the fees due have not been paid.">
              5. Fees due reminders</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Create reminder messages for permit fees due. Will also unsubmit applications where
            payments are overdue.</td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.." rel="tooltip"
              data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runFeesDueTask()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFeesDueVisible"># accounts
                where balance changed and thus no
                reminder sent:
                {{FeesDueTReport["balance_changed_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFeesDueVisible"># applications
                unsubmitted:
                {{FeesDueTReport["unsubmit_count"]}}</label>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFeesDueVisible"># reminders
                sent for application fees due:
                {{FeesDueTReport["app_fee_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFeesDueVisible"># reminders
                sent for permit fees due:
                {{FeesDueTReport["permit_fee_count"]}}</label>
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>

    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="This mainly applies to permits that have gone through a lengthier approval process.
            If a delay has been requested, a message will be sent y days before end of delay and every x days thereafter. 
            This task selects permits that are approved and the details and fee due have not yet been accepted by the carrier
            ">6. Permit confirmation reminders</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Create reminder messages for approved permits needing confirmation.</td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.."
              rel="tooltip" data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runApprovedPermitsTask()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isApprovedPermitsVisible">#
                reminders sent for permits where delays have
                been requested:
                {{ApprovedPermitsReport["permit_delay_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isApprovedPermitsVisible">#
                reminders sent for carriers to confirm and
                pay for approved permits:
                {{ApprovedPermitsReport["permit_confirm_count"]}}</label>
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="Create first time reminder for permit">7. reminder messages for compliance
              returns</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">First time compliance reminder for permits.</td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.."
              rel="tooltip" data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runFirstComplianceReminder()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFirstComplianceReport"># Temp
                Permit Count:
                {{FirstComplianceReport["temp_permit_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFirstComplianceReport"># Temp
                Carrier Count:
                {{FirstComplianceReport["temp_carrier_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFirstComplianceReport"># LT
                Temp Permit Count:
                {{FirstComplianceReport["LT_permit_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isFirstComplianceReport"># LT
                Temp Carrier Count:
                {{FirstComplianceReport["LT_carrier_count"]}}</label> <br />
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>

    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="Create first time reminder for permit">8. reminder messages for compliance
              returns</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Second time compliance reminder for permits.</td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.."
              rel="tooltip" data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runSecondComplianceReminder()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isSecondComplianceReport"># Temp
                Permit Count:
                {{SecondComplianceReport["temp_permit_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isSecondComplianceReport"># Temp
                Carrier Count:
                {{SecondComplianceReport["temp_carrier_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isSecondComplianceReport"># LT
                Temp Permit Count:
                {{SecondComplianceReport["LT_permit_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isSecondComplianceReport"># LT
                Temp Carrier Count:
                {{SecondComplianceReport["LT_carrier_count"]}}</label> <br />
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="Create first time reminder for permit">9. reminder messages for compliance
              returns</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Third Time compliance reminder for permits.</td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.."
              rel="tooltip" data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runThirdComplianceReminder()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isThirdComplianceReport"># Temp
                Permit Count:
                {{ThirdComplianceReport["temp_permit_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isThirdComplianceReport"># Temp
                Carrier Count:
                {{ThirdComplianceReport["temp_carrier_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isThirdComplianceReport"># LT
                Temp Permit Count:
                {{ThirdComplianceReport["LT_permit_count"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isThirdComplianceReport"># LT
                Temp Carrier Count:
                {{ThirdComplianceReport["LT_carrier_count"]}}</label> <br />
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>
    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="Create first time reminder for permit">10. Monthly Compliance Returns Records
            </th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Create the records required to hold the data for the selected month's returns</td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.." rel="tooltip"
              data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runReturnsRecords()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isMonthyComplianceReturn">#
                long_term permit returns created:
                {{ComplianceReturnReport["Created"]}}</label> <br />
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="Create first time reminder for permit">11. Compliance Returns Records for new
              permit</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Create the records required to hold the data for the selected month's returns for newly
            issued permits. /td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.."
              rel="tooltip" data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runReturnsNewRecords()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isMonthyComplianceNew">#
                long_term permit returns created:
                {{ComplianceReturnNewReport["CreatedLong"]}}</label> <br />
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isMonthyComplianceNew">
                # temporary permit returns created:
                {{ComplianceReturnNewReport["CreatedTemp"]}}</label> <br />
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>

    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="Create first time reminder for permit">12. Create Compliance Reminders for long term permits that are due</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Create the reminders for annual compliance data for compliances that are due in 30 days and those have passed the due date.</td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.."
              rel="tooltip" data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runCreateAnnualComplianceReminders()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isAnnualComplianceReminders">#
                long_term annual compliances reminders send:
                {{AnnualComplianceRemindersReport.length}}</label> <br />
                <br />
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="Create first time reminder for permit">13. Create Compliance Records for long term permits that are due</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Create the records required to hold the annual compliance data for compliances that are due in 30 days or less. </td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.."
              rel="tooltip" data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runCreateAnnualComplianceRecords()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isAnnualComplianceRecords">#
                long_term annual compliances created:
                {{AnnualComplianceRecordsReport.length}}</label> <br />
                <br />
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>

    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="Create first time reminder for permit">14. Create Annual Compliance Invoices for long term permits that are due</th>
            <th></th>
            <th></th>

          </tr>
        </thead>
        <tbody>
          <td class="smallbox">Create the invoices for the annual compliances. </td>
          <td class="smallbox">
            <div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runCreateAnnualComplianceInvoices()"
              rel="tooltip" data-placement="top">
              <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                aria-hidden="true"></span>
                <button type="button" class="btn_back" (click)="runCreateAnnualComplianceInvoices()"><img src="assets/blue_play.png" alt="" /></button>
            </div>
          </td>
          <td class="smallbox">
            <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
              <legend class="scheduler-border tsk-display">Process Report</legend>
              <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isAnnualComplianceInvoices">#
                long_term annual compliances invoices created:
                {{AnnualComplianceInvoicesReport.length}}</label> <br />
                <br />
            </fieldset>
          </td>

        </tbody>

      </table>
    </div>
  </div>

  <div class="row">
      <div class="col-sm-6" class="card" style="width: 50%;">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th class="smallbox" title="Create first time reminder for permit">15. Create Mothly Compliance Records </th>
              <th></th>
              <th></th>
  
            </tr>
          </thead>
          <tbody>
            <td class="smallbox">Create Monthly Compliance Records </td>
            <td class="smallbox">
              <div class="main-btn rounded-circle rmp-all" title="Run task.."
                rel="tooltip" data-placement="top">
                <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                  aria-hidden="true"></span>
                  <button type="button" class="btn_back" (click)="runCreateMonthlyComplianceRecords()"><img src="assets/blue_play.png" alt="" /></button>
              </div>
            </td>
            <td class="smallbox">
              <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
                <legend class="scheduler-border tsk-display">Process Report</legend>
                <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isMonthlyComplianceRecords">#
                  Monthly compliances created:
                  {{MonthlyComplianceReport.length}}</label> <br />
                  <br />
              </fieldset>
            </td>
  
          </tbody>
  
        </table>
      </div>
  
      <div class="col-sm-6" class="card" style="width: 50%;">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th class="smallbox" title="Create first time reminder for permit">16. Create Monthly Compliance Reminders</th>
              <th></th>
              <th></th>
  
            </tr>
          </thead>
          <tbody>
            <td class="smallbox">Create Monthly Compliance Reminders. </td>
            <td class="smallbox">
              <div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runCreateMonthlyComplianceReminders()"
                rel="tooltip" data-placement="top">
                <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                  aria-hidden="true"></span>
                  <button type="button" class="btn_back" (click)="runCreateMonthlyComplianceReminders()"><img src="assets/blue_play.png" alt="" /></button>
              </div>
            </td>
            <td class="smallbox">
              <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;">
                <legend class="scheduler-border tsk-display">Process Report</legend>
                <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isMonthlyComplianceReminders">#
                  Monthly compliances reminders send:
                  {{MonthlyComplianceReport.length}}</label> <br />
                  <br />
              </fieldset>
            </td>
  
          </tbody>
  
        </table>
      </div>
  </div>

  <!-- <fieldset class="scheduler-border" style="margin-bottom: 8px !important; padding:0px;">
    <legend class="scheduler-border tsk-display">Create messages for fees due</legend>
    <table class="" style="width:100%!important; padding:0px;" border="0">
      <tr>
        <td>
          <b>Run the process described above</b>
        </td>
        <td align="right">
          <div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runFeesDueTask()"
            style="margin: 0px auto!important; float: right;" rel="tooltip" data-placement="top">
            <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
              aria-hidden="true"></span>
          </div>
        </td>
      </tr>
    </table>
    <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;" *ngIf="isFeesDueVisible">
      <legend class="scheduler-border tsk-display">Process Report</legend>
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># accounts where balance changed and thus no
        reminder sent:
        {{FeesDueTReport["balance_changed_count"]}}</label> <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># applications un-submitted:
        {{FeesDueTReport["unsubmit_count"]}}</label>
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># reminders sent for application fees due:
        {{FeesDueTReport["app_fee_count"]}}</label> <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># reminders sent for permit fees due:
        {{FeesDueTReport["permit_fee_count"]}}</label>
    </fieldset>
  </fieldset> -->



  <!--

    Create reminder messages for approved permits needing confirmation

  -->
  <!-- 
  <div class="row justify-content-center">
    <div class="col-sm-6" class="card" style="width: 50%;">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th class="smallbox" title="This mainly applies to permits that have gone through a lengthier approval process.
            If a delay has been requested, a message will be sent y days before end of delay and every x days thereafter. 
            This task selects permits that are approved and the details and fee due have not yet been accepted by the carrier
            ">Permit confirmation reminders</th>
            <th></th>
            <th></th>
            
            </tr>
            </thead>
            <tbody>
              <td class="smallbox">Create reminder messages for approved permits needing confirmation.</td>
              <td class="smallbox"><div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runApprovedPermitsTask()"
                 rel="tooltip" data-placement="top">
                <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                  aria-hidden="true"></span>
              </div></td>
              <td class="smallbox">
                <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;" >
                  <legend class="scheduler-border tsk-display">Process Report</legend>
                  <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isApprovedPermitsVisible"># reminders sent for permits where delays have
                    been requested:
                    {{ApprovedPermitsReport["permit_delay_count"]}}</label> <br />
                  <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isApprovedPermitsVisible"># reminders sent for carriers to confirm and
                    pay for approved permits:
                    {{ApprovedPermitsReport["permit_confirm_count"]}}</label>
                </fieldset>
              </td>
              
            </tbody>

     </table>
    </div>          
  </div> -->

  <!-- 
  <fieldset class="scheduler-border" style="margin-bottom: 8px !important; padding:0px;">
    <legend class="scheduler-border tsk-display">Create reminder messages for approved permits needing confirmation
    </legend>
    <table class="" style="width:100%!important; padding:0px;" border="0">
      <tr>
        <td>
          <b>Run the process described above</b>
        </td>
        <td align="right">
          <div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runApprovedPermitsTask()"
            style="margin: 0px auto!important; float: right;" rel="tooltip" data-placement="top">
            <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
              aria-hidden="true"></span>
          </div>
        </td>
      </tr>
    </table>
    <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;" *ngIf="isApprovedPermitsVisible">
      <legend class="scheduler-border tsk-display">Process Report</legend>
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># reminders sent for permits where delays have
        been requested:
        {{ApprovedPermitsReport["permit_delay_count"]}}</label> <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># reminders sent for carriers to confirm and
        pay for approved permits:
        {{ApprovedPermitsReport["permit_confirm_count"]}}</label>
    </fieldset>
  </fieldset> -->


  <!--

    Create invoices for permit fees paid

  -->


  <!-- 
  <div class="row">
    <div class="col-sm-12" class="card" style="width: 95%;">
       <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th title="This mainly applies to permits that have gone through a lengthier approval process.
            If a delay has been requested, a message will be sent y days before end of delay and every x days thereafter. 
            This task selects permits that are approved and the details and fee due have not yet been accepted by the carrier
            ">Permit confirmation reminders</th>
            <th></th>
            <th></th>
            
            </tr>
            </thead>
            <tbody>
              <td class="smallbox">Create invoices for permit fees paid</td>
              <td class="smallbox"><div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runInvoicePermitsTask()"
                 rel="tooltip" data-placement="top">
                <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
                  aria-hidden="true"></span>
              </div></td>
              <td class="smallbox">
                <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;" >
                  <legend class="scheduler-border tsk-display">Process Report</legend>
                  <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isInvoicePermitsVisible"># applications processed:
                    {{InvoicePermitsReport["app_count"]}}</label> <br />
                  <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isInvoicePermitsVisible"># permits processed:
                    {{InvoicePermitsReport["permit_count"]}}</label>
                  <br />
                  <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isInvoicePermitsVisible"># application fees and amount invoiced:
                    {{InvoicePermitsReport["app_fee_count"]}} and {{InvoicePermitsReport["invoice_count"]}}</label>
                  <br />
                  <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isInvoicePermitsVisible"># permits fees and amount invoiced:
                    {{InvoicePermitsReport["permit_fee_count"]}} and {{InvoicePermitsReport["invoice_count"]}}</label>
                  <br />
                  <label style="color: #413f3f; font-size: 13px; font-weight: bold;" *ngIf="isInvoicePermitsVisible"># invoices and total:
                    {{InvoicePermitsReport["invoice_count"]}}</label>
                </fieldset>
              </td>
              
            </tbody>

     </table>
    </div>          
  </div> -->


  <!-- <fieldset class="scheduler-border" style="margin-bottom: 8px !important; padding:0px;">
    <legend class="scheduler-border tsk-display">Create invoices for permit fees paid
    </legend>
    <table class="" style="width:100%!important; padding:0px;" border="0">
      <tr>
        <td>
          <b>Run the process described above</b>
        </td>
        <td align="right">
          <div class="main-btn rounded-circle rmp-all" title="Run task.." (click)="runInvoicePermitsTask()"
            style="margin: 0px auto!important; float: right;" rel="tooltip" data-placement="top">
            <span class="fa fa-play-circle-o fa-2x" style="margin:5.5px auto;color:white!important;"
              aria-hidden="true"></span>
          </div>
        </td>
      </tr>
    </table>
    <fieldset class="scheduler-border" style="margin:0px !important;padding:0px;" *ngIf="isInvoicePermitsVisible">
      <legend class="scheduler-border tsk-display">Process Report</legend>
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># applications processed:
        {{InvoicePermitsReport["app_count"]}}</label> <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># permits processed:
        {{InvoicePermitsReport["permit_count"]}}</label>
      <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># application fees and amount invoiced:
        {{InvoicePermitsReport["app_fee_count"]}} and {{InvoicePermitsReport["invoice_count"]}}</label>
      <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># permits fees and amount invoiced:
        {{InvoicePermitsReport["permit_fee_count"]}} and {{InvoicePermitsReport["invoice_count"]}}</label>
      <br />
      <label style="color: #413f3f; font-size: 13px; font-weight: bold;"># invoices and total:
        {{InvoicePermitsReport["invoice_count"]}}</label>
    </fieldset>
  </fieldset> -->
  <br />
</div>
<!--End new design -->